import type {
  CommunicationAudienceSelection,
  ProjectCommunicationAudienceConfig,
} from './types';

export const DEFAULT_PROJECT_COMMUNICATION_AUDIENCES: ProjectCommunicationAudienceConfig = {
  audiences: [
    {
      id: 'cast',
      name: 'Cast',
      rule: 'cast',
      manualIncludeContactIds: [],
      manualExcludeContactIds: [],
      externalRecipients: [],
    },
    {
      id: 'production-team',
      name: 'Production Team',
      rule: 'production-team',
      manualIncludeContactIds: [],
      manualExcludeContactIds: [],
      externalRecipients: [],
    },
    {
      id: 'stage-management',
      name: 'Stage Management',
      rule: 'stage-management',
      manualIncludeContactIds: [],
      manualExcludeContactIds: [],
      externalRecipients: [],
    },
    {
      id: 'design-team',
      name: 'Design Team',
      rule: 'design-team',
      manualIncludeContactIds: [],
      manualExcludeContactIds: [],
      externalRecipients: [],
    },
  ],
  defaults: {
    rehearsalReport: { standingAudienceIds: ['production-team'], contextualAudienceKeys: [] },
    meetingReport: { standingAudienceIds: [], contextualAudienceKeys: ['meeting-attendees'] },
    callSheet: { standingAudienceIds: [], contextualAudienceKeys: ['called-recipients'] },
    announcement: { standingAudienceIds: ['production-team'], contextualAudienceKeys: [] },
    deadlineReminder: { standingAudienceIds: [], contextualAudienceKeys: ['deadline-department'] },
    meetingInvite: { standingAudienceIds: [], contextualAudienceKeys: ['meeting-attendees'] },
  },
};

export const DEFAULT_REPORT_AUDIENCE_SELECTIONS: {
  rehearsalReport: CommunicationAudienceSelection;
  meetingReport: CommunicationAudienceSelection;
} = {
  rehearsalReport: DEFAULT_PROJECT_COMMUNICATION_AUDIENCES.defaults.rehearsalReport,
  meetingReport: DEFAULT_PROJECT_COMMUNICATION_AUDIENCES.defaults.meetingReport,
};
